import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { NmsWizardStepModel,
    AbstractNmsWizardStep,
    NmsWizardStepValidationResponse,
    NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { SchedulerListService } from "@nms-ng2/app/modules/scheduler/scheduler-list/scheduler-list.service";
import { JobType } from "@nms-ng2/app/modules/scheduler/scheduler.models";
import { TriggersValidatorService } from "@nms-ng2/app/modules/scheduler/triggers/triggers-validator.service";
import { AUTHENTICATION_SERVICE, NMS_FEATURES } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { BackupDevicesScheduler } from "./backup-scheduler-tab.model";
import { SchedulerService } from "@nms-ng2/app/modules/scheduler/scheduler.service";
import { CreateBackupService } from "../../create-backup.service";
import { BackupDevicesFilter } from "../backup-devices-tab/backup-devices-tab.model";

/**
 * Aba de configuração de agendamento do backup.
 */
@Component({
    selector: "backup-scheduler-tab",
    templateUrl: "./backup-scheduler-tab.component.html",
    styleUrls: ["./backup-scheduler-tab.component.scss"]
})
export class BackupSchedulerTabComponent extends AbstractNmsWizardStep {
    model: BackupDevicesScheduler = new BackupDevicesScheduler();
    hasSchedulerPermission: boolean;

    constructor(@Inject(AUTHENTICATION_SERVICE) private authenticationService: any,
                @Inject(NMS_FEATURES) private nmsFeatures: any,
                private triggersValidatorService: TriggersValidatorService,
                private schedulerListService: SchedulerListService,
                private schedulerService: SchedulerService,
                private createBackupService: CreateBackupService,
                private ref: ChangeDetectorRef) {
        super();
        this.hasSchedulerPermission = this.authenticationService.hasPermission(this.nmsFeatures.scheduler.feature);
    }

    ngOnInit(): void {
        this.model = new BackupDevicesScheduler();
        this.model.triggers = undefined
        this.ref.detectChanges();
    }

    async allowPrevious(): Promise<NmsWizardStepValidationResponse> {
        return this.validate();
    }

    async allowFinish(): Promise<NmsWizardStepValidationResponse> {
        return this.validate();
    }

    async allowNext(): Promise<NmsWizardStepValidationResponse> {
        return this.validate();
    }

    async finishAction(nmsWizardStepMapData: NmsWizardStepMapData): Promise<void> {
        const schedulerJob = this.createBackupService.buildDeviceBackupScheduler(nmsWizardStepMapData);

        try {
            return this.schedulerListService.save(schedulerJob);
        } finally {
            this.loadingConfig.emit({ showLoading: false });
        }
    }

    async comingFromPreviousStep(backupDevicesFilter: BackupDevicesFilter,
                                 wizardStepsCacheMap: NmsWizardStepMapData): Promise<BackupDevicesScheduler> {
        this.model = wizardStepsCacheMap["BackupDevicesScheduler"] as BackupDevicesScheduler || this.model;

        if (!this.model.triggers) {
            this.fillInitialData();
        }

        return Promise.resolve(this.model)
    }

    goingToNextStep(): Promise<NmsWizardStepModel> {
        return Promise.resolve(this.model);
    }

    private fillInitialData() {
        const schedulerJob = this.schedulerService.initSchedulerJob(null, JobType.BACKUP);

        this.model.triggers = schedulerJob.triggers;
        this.model.jobType = schedulerJob.type;
    }

    private validate(): Promise<NmsWizardStepValidationResponse> {
        if (this.triggersValidatorService.validate(this.model.triggers)) {
            return Promise.resolve(new NmsWizardStepValidationResponse(true));
        }

        return Promise.reject(new NmsWizardStepValidationResponse(false));
    }
}
